export default __webpack_public_path__ + "static/media/coupons.06ba4ac6.png";